const Ai = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' {...props}>
    <path
      d='M13.999 8.00049L10.2935 7.2998C9.89851 7.22514 9.53523 7.0332 9.25098 6.74902C8.96667 6.46471 8.77438 6.10114 8.69971 5.70605L7.99902 2.00049L7.29785 5.70605C7.22318 6.10113 7.03138 6.46472 6.74707 6.74902C6.46276 7.03333 6.09917 7.22513 5.7041 7.2998L1.99854 8.00049L5.7041 8.70166C6.09918 8.77633 6.46276 8.96862 6.74707 9.25293C7.03125 9.53718 7.22318 9.90046 7.29785 10.2954L7.99854 14.001L8.69971 10.2954C8.77439 9.90037 8.96669 9.53722 9.25098 9.25293C9.53526 8.96864 9.89841 8.77634 10.2935 8.70166L13.999 8.00049ZM15.334 8.00098C15.3339 8.31198 15.225 8.61325 15.0264 8.85254C14.8276 9.0919 14.551 9.25439 14.2451 9.31152L14.2446 9.31104L10.5415 10.0117C10.4099 10.0366 10.2881 10.1006 10.1934 10.1953C10.0986 10.2901 10.0347 10.4113 10.0098 10.543L9.30908 14.2466L9.30957 14.2471C9.25244 14.5529 9.08995 14.8295 8.85059 15.0283C8.6113 15.227 8.31003 15.3359 7.99902 15.3359C7.68792 15.3359 7.38632 15.2271 7.14697 15.0283C6.90761 14.8295 6.74512 14.5529 6.68799 14.2471L5.98779 10.5435C5.96288 10.4118 5.89893 10.29 5.8042 10.1953C5.70944 10.1006 5.5882 10.0366 5.45654 10.0117L1.75244 9.31104C1.44658 9.25391 1.17047 9.0919 0.97168 8.85254C0.772926 8.61322 0.664108 8.31206 0.664062 8.00098C0.664062 7.68982 0.772884 7.38829 0.97168 7.14893C1.14562 6.93952 1.3787 6.78891 1.63916 6.71631L1.75244 6.68994L5.45605 5.98975C5.58773 5.96485 5.70944 5.90091 5.8042 5.80615C5.89896 5.71139 5.9629 5.59017 5.98779 5.4585L6.68848 1.75293C6.74584 1.44768 6.90803 1.17211 7.14697 0.973633C7.38634 0.774837 7.68787 0.666016 7.99902 0.666016C8.31011 0.666061 8.61127 0.774879 8.85059 0.973633C9.08956 1.17211 9.25171 1.44766 9.30908 1.75293L10.0098 5.45801C10.0347 5.58966 10.0986 5.7114 10.1934 5.80615C10.2881 5.90094 10.4098 5.96486 10.5415 5.98975L14.2446 6.68994C14.5505 6.74707 14.8276 6.90956 15.0264 7.14893C15.2251 7.38827 15.334 7.68988 15.334 8.00098Z'
      fill='url(#paint0_linear_1847_13488)'
    />
    <path
      d='M12.666 3.99902V3.33252H11.9995C11.6314 3.33252 11.3331 3.03413 11.333 2.66602C11.333 2.29783 11.6313 1.99902 11.9995 1.99902H12.666V1.33252C12.666 0.96433 12.9648 0.666016 13.333 0.666016C13.7011 0.666103 13.9995 0.964384 13.9995 1.33252V1.99902H14.666C15.0342 1.99902 15.333 2.29783 15.333 2.66602C15.3329 3.03413 15.0342 3.33252 14.666 3.33252H13.9995V3.99902C13.9995 4.36716 13.7011 4.66593 13.333 4.66602C12.9648 4.66602 12.666 4.36721 12.666 3.99902Z'
      fill='url(#paint1_linear_1847_13488)'
    />
    <path
      d='M3.33252 13.334C3.33252 12.9658 3.03413 12.6671 2.66602 12.667C2.29783 12.667 1.99902 12.9658 1.99902 13.334C1.99911 13.7021 2.29788 14.0005 2.66602 14.0005C3.03408 14.0004 3.33243 13.702 3.33252 13.334ZM4.66602 13.334C4.66593 14.4384 3.77046 15.3339 2.66602 15.334C1.5615 15.334 0.666104 14.4385 0.666016 13.334C0.666016 12.2294 1.56145 11.334 2.66602 11.334C3.77051 11.3341 4.66602 12.2295 4.66602 13.334Z'
      fill='url(#paint2_linear_1847_13488)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1847_13488'
        x1='4.6459'
        y1='2.49976'
        x2='12.3378'
        y2='3.67186'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#7B5DE6' />
        <stop offset='0.456731' stopColor='#DE8FE9' />
        <stop offset='1' stopColor='#FBB5C0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1847_13488'
        x1='4.6459'
        y1='2.49976'
        x2='12.3378'
        y2='3.67186'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#7B5DE6' />
        <stop offset='0.456731' stopColor='#DE8FE9' />
        <stop offset='1' stopColor='#FBB5C0' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_1847_13488'
        x1='4.6459'
        y1='2.49976'
        x2='12.3378'
        y2='3.67186'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#7B5DE6' />
        <stop offset='0.456731' stopColor='#DE8FE9' />
        <stop offset='1' stopColor='#FBB5C0' />
      </linearGradient>
    </defs>
  </svg>
);

export default Ai;
